// 导入自有语言包
// CCUI统一标准语言标识
// ar 阿拉伯语（暂定）
// en-gb 英语
// fr-fr 法语
// es-es 西班牙语
// ru-ru 俄语
// zh-cn 中文
import zhCN from "./locale/zh-CN";
import enUS from "./locale/en-US";
import albAR from "./locale/ar";
import faFR from "./locale/fr";
import esEs from "./locale/es";
import elsRU from "./locale/ru-RU";

// 导入布局语言包
import layoutLocale from "./locale/layoutLocaleI18n";

// 合并语言包
export default {
  "zh-cn": Object.assign(zhCN, layoutLocale["zh-CN"]), // 中文
  "en-gb": Object.assign(enUS, layoutLocale["en-US"]), //英语
  "es-es": Object.assign(esEs, layoutLocale["es-ES"]), // 西班牙语
  "fr-fr": Object.assign(faFR, layoutLocale["fa-FR"]), // 法语
  "ru-ru": Object.assign(elsRU, layoutLocale["els-RU"]), // 俄语
  ar: Object.assign(albAR, layoutLocale["alb-AR"]) // 阿拉伯语
};
